export default __webpack_public_path__ + "static/media/facebook.634238e6.png";